// removed by extract-text-webpack-plugin
module.exports = {"statusWarp":"pages-MyAccount-BidVerfiy-component-status-statusWarp","icon":"pages-MyAccount-BidVerfiy-component-status-icon","icon-pending":"pages-MyAccount-BidVerfiy-component-status-icon-pending","icon-notverify":"pages-MyAccount-BidVerfiy-component-status-icon-notverify","icon-success":"pages-MyAccount-BidVerfiy-component-status-icon-success","title":"pages-MyAccount-BidVerfiy-component-status-title","desc":"pages-MyAccount-BidVerfiy-component-status-desc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/MyAccount/BidVerfiy/component/status/index.css
// module id = 1793
// module chunks = 0